var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pagination',{attrs:{"per-page":_vm.perPage,"records":_vm.totalRows,"options":_vm.options},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }